import { __extends, __assign } from 'tslib';
import * as React from 'react';
import { tooltipUniqueId } from './TooltipWrapper.js';

var tooltipGap = 20;
var TooltipDecoratorClass = function () {
    return function (Component) {
        var _a;
        var result = (_a = (function (_super) {
                __extends(TooltipDecorator, _super);
                function TooltipDecorator() {
                    var _this = _super !== null && _super.apply(this, arguments) || this;
                    _this.onMouseEnter = function (e) {
                        if (_this.props.tooltipBody !== null && _this.props.tooltipBody !== undefined && !_this.props.isDisabled) {
                            if (window === null || window === void 0 ? void 0 : window.tooltipProvider) {
                                var delay = _this.props.delay ? _this.props.delay : 0;
                                setTimeout(function () {
                                    if (window.tooltipProvider) {
                                        window.tooltipProvider.show(_this.props.tooltipBody);
                                        _this.onMouseMove(e);
                                    }
                                }, delay);
                            }
                        }
                    };
                    _this.onMouseLeave = function (e) {
                        if (window === null || window === void 0 ? void 0 : window.tooltipProvider) {
                            window.tooltipProvider.hide();
                        }
                    };
                    _this.onMouseMove = function (e) {
                        var cursorX = e.pageX - window.scrollX;
                        var cursorY = e.pageY - window.scrollY + tooltipGap;
                        var isDisabledTooltip = !_this.props.tooltipBody || _this.props.isDisabled;
                        if (isDisabledTooltip) {
                            return;
                        }
                        var tooltipBody = document.getElementById(tooltipUniqueId);
                        if (_this.props.fixed && _this.wrapper && tooltipBody) {
                            tooltipGap = 10;
                            var wrapperBox = _this.wrapper.getBoundingClientRect();
                            var bodyBox = tooltipBody.getBoundingClientRect();
                            switch (_this.props.position) {
                                case 'top': {
                                    cursorX = wrapperBox.x + wrapperBox.width / 2 - bodyBox.width / 2;
                                    cursorY = wrapperBox.y - bodyBox.height - tooltipGap;
                                    break;
                                }
                                case 'right': {
                                    cursorX = wrapperBox.x + wrapperBox.width + tooltipGap;
                                    cursorY = wrapperBox.y;
                                    break;
                                }
                                case 'center-right': {
                                    cursorX = wrapperBox.x + wrapperBox.width + tooltipGap;
                                    cursorY = wrapperBox.y + wrapperBox.height / 2 - bodyBox.height / 2;
                                    break;
                                }
                                case 'bottom': {
                                    cursorX = wrapperBox.x + wrapperBox.width / 2 - bodyBox.width / 2;
                                    cursorY = wrapperBox.y + bodyBox.height + tooltipGap;
                                    break;
                                }
                                case 'left': {
                                    cursorX = wrapperBox.x - bodyBox.width - tooltipGap;
                                    cursorY = wrapperBox.y;
                                    break;
                                }
                                case 'center-left': {
                                    cursorX = wrapperBox.x - bodyBox.width - tooltipGap;
                                    cursorY = wrapperBox.y + wrapperBox.height / 2 - bodyBox.height / 2;
                                    break;
                                }
                            }
                        }
                        if (cursorX < tooltipGap) {
                            cursorX = tooltipGap;
                        }
                        if (cursorY < tooltipGap) {
                            cursorY = tooltipGap;
                        }
                        if (window === null || window === void 0 ? void 0 : window.tooltipProvider) {
                            window.tooltipProvider.setBodyContentIfNeeded(_this.props.tooltipBody);
                            window.tooltipProvider.update({ x: cursorX, y: cursorY });
                        }
                    };
                    return _this;
                }
                TooltipDecorator.prototype.componentWillUnmount = function () {
                    if (window === null || window === void 0 ? void 0 : window.tooltipProvider) {
                        window.tooltipProvider.hide();
                    }
                };
                TooltipDecorator.prototype.render = function () {
                    var _this = this;
                    return (React.createElement(Component, __assign({}, this.props, { ref: function (r) {
                            if (r) {
                                _this.wrapper = r;
                            }
                        }, onMouseEnter: this.onMouseEnter, onMouseLeave: this.onMouseLeave, onMouseMove: this.onMouseMove })));
                };
                return TooltipDecorator;
            }(React.Component)),
            _a.displayName = "TooltipDecorator(" + (Component.displayName || Component.name) + ")",
            _a.defaultProps = {
                isDisabled: false,
            },
            _a);
        return result;
    };
};

export { TooltipDecoratorClass as default };
//# sourceMappingURL=TooltipDecorator.js.map
